import { Component } from 'react';
import { compose } from 'redux';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { roleCheck } from '../../helpers/roleCheck';
import { changeSubMenuState, resetSubMenu, setMenuPathActive, setSubMenuItems, setSubMenuPathActive } from '../../reducers/subMenuActions';
import { activePathCheck } from '../../helpers/routeHelper';

class MenuElement extends Component {
  componentDidMount() {
    const availableUrls = roleCheck(this.props.authReducer.roles, this.props.to, this.props.userInfo).availableUrls;
    if (activePathCheck(this.props.location.pathname, availableUrls)) {
      if (this.props.subElements) {
        this.props.dispatch(setSubMenuItems(availableUrls));
        this.props.dispatch(changeSubMenuState(true));
        this.props.dispatch(setSubMenuPathActive(true));
        this.props.dispatch(setMenuPathActive(false));
      } else {
        this.props.dispatch(setSubMenuPathActive(false));
        this.props.dispatch(setMenuPathActive(true));
      }
    }
  }
  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, _prevState, _snapshot) {
    const availableUrls = roleCheck(this.props.authReducer.roles, this.props.to, this.props.userInfo).availableUrls;
    if (this.props.subMenuReducer.subMenuItems.length !== availableUrls.length && this.props.subElements) {
      this.props.dispatch(setSubMenuItems(availableUrls));
    }
    if (activePathCheck(this.props.location.pathname, availableUrls) && this.props.subElements && !this.props.subMenuReducer.subMenuOpen) {
      this.props.dispatch(setSubMenuItems(availableUrls));
      this.props.dispatch(changeSubMenuState(true));
      this.props.dispatch(setSubMenuPathActive(true));
    }

    if (this.props.location.pathname !== prevProps.location.pathname) {
      if (activePathCheck(this.props.location.pathname, availableUrls)) {
        if (this.props.subElements) {
          this.props.dispatch(setSubMenuItems(availableUrls));
          this.props.dispatch(changeSubMenuState(true));
          this.props.dispatch(setSubMenuPathActive(true));
          this.props.dispatch(setMenuPathActive(false));
        } else {
          this.props.dispatch(setSubMenuPathActive(false));
          this.props.dispatch(setMenuPathActive(true));
        }
      }
    }
  }

  render() {
    const roleChecked = roleCheck(this.props.authReducer.roles, this.props.to, this.props.userInfo);
    const accessDenied = !roleChecked.result;
    const accessibleUrls = roleChecked.availableUrls;
    if (accessDenied) {
      return <></>;
    }
    if (!this.props.subElements) {
      const resetOnHover = () => {
        if (!this.props.subMenuReducer.subMenuPathActive) {
          if (this.props.subMenuReducer.subMenuOpen) {
            this.props.dispatch(resetSubMenu());
          }
        }
      };
      return (
        <>
          <li onClick={() => this.props.dispatch(resetSubMenu())} onMouseEnter={() => resetOnHover()}>
            <NavLink to={this.props.to} className={this.props.className}>
              {this.props.children}
            </NavLink>
          </li>
          <span className='separator' />
        </>
      );
    } else {
      const handleClick = () => {
        this.props.dispatch(setSubMenuItems(accessibleUrls));
        this.props.dispatch(changeSubMenuState(true));
      };
      const handleHover = !this.props.subMenuReducer.subMenuPathActive ? () => handleClick() : () => {};
      return (
        <>
          <li onClick={() => handleClick()} onMouseEnter={handleHover}>
            <NavLink to={accessibleUrls[0]} className={`subMenuElement-wrapper ${this.props.className}`}>
              {this.props.children}
            </NavLink>
          </li>
          <span className='separator' />
        </>
      );
    }
  }
}

MenuElement.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  className: PropTypes.string,
  separator: PropTypes.bool,
  subElements: PropTypes.bool,
};

MenuElement.defaultProps = {
  className: '',
  separator: false,
};

const enhance = compose(
  withRouter,
  connect((state) => state)
);

export default enhance(MenuElement);
